module.exports = "/frontend/img/logo-kb-l-3x.png";